import React, { forwardRef } from 'react';

function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

const gapToClass = (gap) => {
  if (typeof gap === 'number') return `gap-${gap}`;
  const map = {
    none: 'gap-0',
    xs: 'gap-1',
    sm: 'gap-2',
    md: 'gap-3',
    lg: 'gap-4',
    xl: 'gap-6',
    '2xl': 'gap-8',
  };
  return map[gap] || map.md;
};

const alignToClass = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
  baseline: 'items-baseline',
};

const justifyToClass = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
  evenly: 'justify-evenly',
};

const Column = forwardRef(function Column(
  {
    as: As = 'div',
    children,
    gap = 'md',
    align = 'stretch',
    justify = 'start',
    fullHeight = false,
    fullWidth = true,
    divider = false,
    className,
    style,
    ...rest
  },
  ref
) {
  const classes = cn(
    'flex flex-col',
    fullWidth && 'w-full',
    fullHeight && 'h-full',
    gapToClass(gap),
    alignToClass[align] || '',
    justifyToClass[justify] || '',
    divider && 'divide-y divide-gray-200',
    className
  );

  return (
    <As ref={ref} className={classes} style={style} {...rest}>
      {children}
    </As>
  );
});

Column.displayName = 'Column';

export default Column;